module.exports = __webpack_public_path__ + "d69360f2.webp";